import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BzgStatusPagesComponent } from './status-pages/status-pages.component';
import { BzgButtonModule } from 'bz-genome-angular';

@NgModule({
  declarations: [
    BzgStatusPagesComponent
  ],
  imports: [
    CommonModule,
    BzgButtonModule
  ],
  exports: [
    BzgStatusPagesComponent
  ]
})
export class BzgStatusPagesModule {}